// バージョン選択と削除モーダル操作
import { ref } from 'vue';
import { findVideoItemById } from './useItemTypeGuards';

export const useVersionActions = ({
  items,
  selectedFolderId,
  selectFolder,
  selectItem,
  detailSubTab,
  removeFromShareBasket,
}) => {
  const deleteTargetItem = ref({ id: null, name: '', version_count: 0 });
  const deleteMode = ref('single');
  const deleteVersionsList = ref([]);
  const deleteVersionsLoading = ref(false);

  const fetchDeleteVersionsList = async (videoId) => {
    deleteVersionsLoading.value = true;
    try {
      const response = await window.axios.get(`/api/videos/${videoId}/versions`);
      const payload = response?.data?.versions ?? [];
      const versions = Array.isArray(payload) ? payload : [];
      deleteVersionsList.value = versions.filter((version) => !version?.deleted_at);
    } catch (error) {
      deleteVersionsList.value = [];
    } finally {
      deleteVersionsLoading.value = false;
    }
  };

  const showDeleteModal = (item) => {
    if (!item) {
      return;
    }
    deleteTargetItem.value = item;
    deleteMode.value = 'single';
    deleteVersionsList.value = [];
    if (item.version_count > 1) {
      fetchDeleteVersionsList(item.id);
    }
    if (window.jQuery) {
      window.jQuery('#versionDeleteModal').modal('show');
    }
  };

  const fetchVideoItem = async (videoId) => {
    const response = await window.axios.get(`/api/videos/${videoId}`);
    const payload = response?.data?.item ?? response?.data ?? null;
    return payload && typeof payload === 'object' ? payload : null;
  };

  const normalizeFolderId = (folderId) => {
    const parsed = Number(folderId);
    if (!Number.isFinite(parsed)) {
      return null;
    }
    const normalized = Math.trunc(parsed);
    return normalized > 0 ? normalized : null;
  };

  const handleVersionSelect = async (version) => {
    if (!version || !version.id) {
      return;
    }
    const targetId = String(version.id);
    const found = findVideoItemById(items.value, targetId);
    if (found) {
      selectItem(found);
      detailSubTab.value = 'info';
      return;
    }

    try {
      const fetchedItem = await fetchVideoItem(targetId);
      if (!fetchedItem) {
        window.alert('バージョンの詳細を取得できませんでした。');
        return;
      }

      const targetFolderId = normalizeFolderId(fetchedItem.folder_id);
      const currentFolderId = normalizeFolderId(selectedFolderId.value);
      if (targetFolderId !== null && currentFolderId !== targetFolderId) {
        await selectFolder(targetFolderId);
        const refreshed = findVideoItemById(items.value, targetId);
        selectItem(refreshed || fetchedItem);
      } else {
        selectItem(fetchedItem);
      }
      detailSubTab.value = 'info';
    } catch (error) {
      const message =
        error?.response?.data?.message || 'バージョンの詳細を取得できませんでした。';
      window.alert(message);
    }
  };

  const confirmDelete = () => {
    const target = deleteTargetItem.value;
    if (!target || !target.id) {
      return;
    }

    if (deleteMode.value === 'all') {
      deleteVersionsList.value.forEach((version) => {
        if (version && version.id) {
          removeFromShareBasket(version.id);
        }
      });
    }
    removeFromShareBasket(target.id);

    const url =
      deleteMode.value === 'all'
        ? `/dashboard/videos/${target.id}/remove-all-versions`
        : `/dashboard/videos/${target.id}/remove`;
    window.location.href = url;
  };

  return {
    deleteTargetItem,
    deleteMode,
    deleteVersionsList,
    deleteVersionsLoading,
    showDeleteModal,
    handleVersionSelect,
    confirmDelete,
  };
};
